import React from 'react';
import { getConfiguration } from '../../utils/configuration';
import { getFormattedTimestamp } from '../../utils/getFormattedTimestamp';
import { getCurrencyValue } from '../../utils/getCurrencyValue';
import ShopReceiptHeader from './common-includes/ShopReceiptHeader';
import ShopReceiptFooter from './common-includes/ShopReceiptFooter';
import { getLabel } from '../../../data/labels';


function AccountRechargeReceipt(props) {
	const conf = getConfiguration();
	
	const additionalStyle = {
			"fontFamily" : "sans-serif",
			"fontSize" : "19px"
	};

	
	const opData = props.data;
	const operationTitle = getLabel('retail.account_recharge.title') || 'Account recharge';
	const formattedTimestamp =  opData.formattedTimestamp || getFormattedTimestamp();
	const amountWithCurrency = opData.amountWithCurrency || getCurrencyValue(opData.amount, conf.cs.m, conf.cs.nd, conf.cs.ct);
	const terminalBalance = getCurrencyValue(opData.terminalBalance, conf.cs.m, conf.cs.nd, conf.cs.ct);

	const dateTimeLabel = getLabel('retail.date_time');
	const amountLabel = getLabel('retail.amount');
	const terminalLabel = getLabel('retail.terminal_number');
	const operatorLabel = getLabel('retail.operator');	
	return (
		<body style={additionalStyle}>

			<ShopReceiptHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} operationTitle={operationTitle}></ShopReceiptHeader>
			
			<div>{dateTimeLabel + ": " + formattedTimestamp}</div>
			<div>{amountLabel + ": " + amountWithCurrency}</div>
			{
				opData.accountNumber?.length > 0 &&
				<div>{getLabel('retail.account_recharge.account_num') + ": " + opData.accountNumber}</div>
			}
			{
				opData.userNickname?.length > 0 &&
				<div>{getLabel('general.username') + ": " + opData.userNickname}</div>
			}			
			{
				opData.showTerminalBalance && <div>{getLabel('retail.terminal_balance') + ": " + terminalBalance}</div>
			}
			<div>{terminalLabel + ": " + opData.idTag}</div>
			{ 
				opData.showOperatorName && <div>{operatorLabel + ": " + opData.operator}</div>
			}
			<hr className="hr-line" />
			<div className="centerText">{opData.idt}</div>		
			<ShopReceiptFooter></ShopReceiptFooter>
		</body>
    );
}

export default AccountRechargeReceipt;